import React from 'react';
import cn from 'classnames';
import { Form } from 'antd';
import styles from './FormItem.module.scss';

const FormItem = ({ className, ...props }) => {
  return (
    <Form.Item
      {...props}
      className={cn(styles.root, className)}
    />
  );
};

export default FormItem;
